(function () {
    'use strict';

    angular
        .module('app')
        .factory('QueueService', QueueService);

    QueueService.$inject = ['$http', '$timeout'];

    function QueueService($http, $timeout) {

        var service = {
            getList: getList,
            getStats: getStats,
            getStatus: getStatus,
            createCommand: createCommand,
            checkStatus: checkStatus,
            loadingModal: loadingModal,
            retry: retry,
            cancelJob: cancelJob
        };

        return service;

        function getList(callback) {
            $http.get('/backend/altcrm/queue/list')
                .success(function (data) {
                    callback(data);
                });
        }

        function getStats(callback) {
            $http.get('/backend/altcrm/queue/stats')
                .success(function (data) {
                    callback(data);
                });
        }

        function getStatus(jobId, callback) {
            $http.get('/backend/altcrm/queue/status', {
                params: {
                    jobId: jobId
                }
            })
                .success(function (data) {
                    callback(data);
                });
        }

        /**
         * Crear modal dinámicamente si no existe
         */
        function ensureModal() {
            if (!document.getElementById("queueLoadingModal")) {
                const html = `
                <div class="modal fade" id="queueLoadingModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false">
                  <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                      <div class="modal-body d-flex flex-column align-items-center justify-content-center py-4">
                        <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;"></div>
                        <h5 id="queueLoadingTitle">Procesando…</h5>
                        <p id="queueLoadingMessage" class="text-muted"></p>
                      </div>
                    </div>
                  </div>
                </div>`;

                const container = document.createElement("div");
                container.innerHTML = html;
                document.body.appendChild(container);
            }
        }

        /**
         * Mostrar modal y hacer polling
         * RETURN: Promise que se resuelve cuando acaba
         */
        function loadingModal(title, message, command_id) {
            ensureModal();

            // Actualizar textos
            document.getElementById("queueLoadingTitle").innerText = title;
            document.getElementById("queueLoadingMessage").innerText = message;

            const modalEl = document.getElementById("queueLoadingModal");
            const modal = new bootstrap.Modal(modalEl);

            modal.show();

            // Devolver promesa
            return new Promise((resolve, reject) => {
                function poll() {
                    checkStatus(command_id).then(status => {
                        if (status === false) {
                            modal.hide();
                            resolve(true); // TERMINADO
                        } else {
                            // continuar esperando
                            $timeout(poll, 1500);
                        }
                    }).catch(() => {
                        modal.hide();
                        reject("Error en checkStatus");
                    });
                }
                poll(); // inicial
            });
        }

        /**
         * Crear comando en la cola
         */
        function createCommand(command) {
            var data = $.param({ command: command });
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            };
            return $http.post('/backend/altcrm/queue/create-command', data, config)
                .then(res => res.data)
                .catch(() => false);
        }

        /**
         * Comprobar si sigue corriendo (devuelve false si ha terminado)
         */
        function checkStatus(command_id) {
            return $http.get("/backend/altcrm/queue/check-command-status", {
                params: {
                    job_id: command_id
                }
            })
                .then(res => res.data)
                .catch(() => false);
        }

        /**
         * Cancelar un trabajo
         */
        function cancelJob(jobId) {
            return $http.post("/backend/altcrm/queue/cancel", null, {
                params: {
                    jobId: jobId
                }
            })
                .then(res => res.data)
                .catch(() => ({ success: false, message: 'Error cancelling job' }));
        }

        function retry(jobId, callback) {
            $http.get('/backend/altcrm/queue/retry', {
                params: {
                    jobId: jobId
                }
            })
                .success(function (data) {
                    if (callback) callback(data);
                });
        }
    }
})();
